/**
 * SVG Path Flowing Animation Generator
 * SVGパスフローアニメーションジェネレーター
 * 
 * Creates flowing line animations on SVG paths with synchronized timing
 * 同期したタイミングでSVGパスに流れる線アニメーションを作成
 * 
 * @param {Object} options - Configuration options / 設定オプション
 * @returns {void}
 */
function createFlowingLineAnimation(options = {}) {
    // Default configuration / デフォルト設定
    const DEFAULT_CONFIG = {
        animationDuration: 3,           // Animation duration in seconds (same for all paths) / アニメーション時間（秒、全パス共通）
        animationDelay: 0,              // Animation delay in seconds (negative value to start mid-animation) / アニメーション遅延（秒、負の値で途中から開始）
        whiteSegmentRatio: 0.15,        // White segment ratio of path length / 白色線分の割合
        minWhiteSegmentLength: 0,       // Minimum white segment length / 白色線分の最小長
        minPathLength: 0,               // Minimum path length threshold / 最小パス長閾値
        timingFunction: 'linear',       // Animation timing function / アニメーションのタイミング関数
        targetGroupClass: 'map',        // Target SVG container class / 対象SVGコンテナクラス
        originalPathClass: 'line',      // Original path class name / 元のパスのクラス名
        newPathClass: 'white-flow-line' // New flowing line class name / 新しい流れる線のクラス名
    };

    // Merge user options with defaults / ユーザーオプションとデフォルトをマージ
    const CONFIG = { ...DEFAULT_CONFIG, ...options };

    // Get all map containers / すべてのマップコンテナを取得
    const mapContainers = document.querySelectorAll(`.${CONFIG.targetGroupClass}`);
    if (mapContainers.length === 0) {
        console.warn(`No containers found with class "${CONFIG.targetGroupClass}"`);
        return;
    }

    // Create stylesheet once / スタイルシートを一度作成
    const styleElement = document.createElement('style');
    document.head.appendChild(styleElement);
    const styleSheet = styleElement.sheet;

    // Process each map container / 各マップコンテナを処理
    mapContainers.forEach((container, containerIndex) => {
        // Find all paths with the original class inside container / コンテナ内の元のクラスを持つすべてのパスを検索
        const paths = Array.from(container.querySelectorAll(`path.${CONFIG.originalPathClass}`)).filter(path => {
            return path.getTotalLength() > CONFIG.minPathLength;
        });

        if (paths.length === 0) {
            console.warn(`No valid paths found in container ${containerIndex}`);
            return;
        }

        // Create animations for each path / 各パスのアニメーションを作成
        paths.forEach((originalPath, index) => {
            const pathLength = originalPath.getTotalLength() * 2;

            // Calculate dash array values / ダッシュ配列の値を計算
            const whiteSegmentLength = Math.max(pathLength * CONFIG.whiteSegmentRatio, CONFIG.minWhiteSegmentLength);
            const gapLength = pathLength - whiteSegmentLength;

            // Create white flowing line / 白色の流れる線を作成
            const whitePath = originalPath.cloneNode(true);
            whitePath.classList.remove(CONFIG.originalPathClass);
            whitePath.classList.add(CONFIG.newPathClass);

            // Set dash array style / ダッシュ配列スタイルを設定
            whitePath.style.strokeDasharray = `${whiteSegmentLength} ${gapLength}`;
            whitePath.style.strokeDashoffset = pathLength;

            // Use fixed animation duration for all paths to sync start and end / 開始と終了を同期するために全パスで固定のアニメーション時間を使用

            // Create keyframe animation with unique name per container / コンテナごとに一意の名前でキーフレームアニメーションを作成
            const animationName = `whiteFlow_${containerIndex}_${index}`;

            try {
                // Create simple continuous flow keyframes / 単純な連続流動キーフレームを作成
                const keyframes = `
                    @keyframes ${animationName} {
                        0% {
                            stroke-dashoffset: ${pathLength};
                        }

                        100% {
                            stroke-dashoffset: 0;
                        }
                    }
                `;
                styleSheet.insertRule(keyframes, styleSheet.cssRules.length);

                // Apply animation with configurable delay / 設定可能な遅延でアニメーションを適用
                whitePath.style.animation = `${animationName} ${CONFIG.animationDuration}s ${CONFIG.timingFunction} infinite`;
                whitePath.style.animationDelay = `${CONFIG.animationDelay}s`;

            } catch (e) {
                console.warn(`Failed to create animation for container ${containerIndex}, path ${index}:`, e);
            }

            // Append to the parent group of the original path / 元のパスの親グループに追加
            originalPath.parentNode.appendChild(whitePath);
        });
    });
}

// Initialize on DOM ready / DOM準備完了時に初期化
document.addEventListener('DOMContentLoaded', function () {
    // Default usage with no custom options / カスタムオプションなしのデフォルト使用
    createFlowingLineAnimation();
    
    // Example: Custom usage with different settings / 例：異なる設定でのカスタム使用
    // createFlowingLineAnimation({
    //     animationDuration: 3,          // Slower animation / より遅いアニメーション
    //     whiteSegmentRatio: 0.5,
    //     timingFunction: 'ease-in-out',
    //     targetGroupClass: 'custom-map'
    // });
});